const globalStyles = {
  globalStyle: {
    "*::-webkit-scrollbar": {
      width: "0.4em",
      height: "0.5em",
      backgroundColor: "transparent",
    },
    "*::-webkit-scrollbar-track": {
      WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: "3px",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--mui-palette-primary-main-semi)",
      borderRadius: "3px",
      transition: "background 0.2s ease",
      "&:hover, &:focus": {
        backgroundColor: "var(--mui-palette-primary-main)",
      },
    },
    // Firefox scrollbar styling
    "*": {
      scrollbarWidth: "thin",
      scrollbarColor: "var(--mui-palette-primary-main-semi) transparent",
    },
  },
};

export default globalStyles;
